var protoAccess = {};

export { protoAccess as __exports };
